import React, { useEffect, useState } from "react";
import Table from "../../EntryFile/datatable";
import FeatherIcon from "feather-icons-react";
import { Link, useHistory } from "react-router-dom";
import alertify from "alertifyjs";
import { Modal, Button, Form } from "react-bootstrap";
import { DeleteIcon, EditIcon, EyeIcon } from "../../EntryFile/imagePath";
import Tabletop from "../../EntryFile/tabletop";
import { getAppointments, deleteAppointment } from "../../core/api/appointment";
import Swal from "sweetalert2";

const AppointmentsCRUD = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [filterStatus, setFilterStatus] = useState("pending");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const history = useHistory();

  const columns = [
    {
      title: "First Name",
      dataIndex: "patient",
      render: (patient) => `${patient?.firstName || "-"}`,
    },
    {
      title: "Surname",
      dataIndex: "patient",
      render: (patient) => `${patient?.surname || "-"}`,
    },
    {
      title: "ID/Passport",
      dataIndex: "patient",
      render: (patient) => `${patient?.idOrPassport || "-"}`,
    },
    {
      title: "Phone Number",
      dataIndex: "patient",
      render: (patient) => `${patient?.phoneNumber || "-"}`,
    },
    {
      title: "Service Provided",
      dataIndex: "services",
      render: (services) => (services.length ? services[0]?.name : "-"),
    },
    {
      title: "Consulting Doctor",
      dataIndex: "employee",
      render: (employee) => `${employee?.firstName || "-"}`,
    },
    {
      title: "Appointment Date",
      dataIndex: "appointmentDate",
      render: (date) => new Date(date).toLocaleDateString() || "-",
    },
    {
      title: "Appointment Time",
      dataIndex: "appointmentTime",
      render: (time) => time || "-",
    },
    {
      title: "Actions",
      render: (record) => (
        <>
          <Link className="me-3" to={`view-appointment/${record?.id}`}>
            <img src={EyeIcon} alt="View" />
          </Link>
          <Link className="me-3" to={`appointment/manage?id=${record?.id}`}>
            <img src={EditIcon} alt="Edit" />
          </Link>
          <Link
            className="confirm-text"
            to="#"
            onClick={() => handleDeleteAppointment(record?.id)}
          >
            <img src={DeleteIcon} alt="Delete" />
          </Link>
        </>
      ),
    },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getAppointments({
        page,
        limit: pageSize,
        search,
        status: filterStatus,
      });
      setData(result?.data?.appointments);
      setTotalItems(result?.data?.totalAppointments);
    } catch (error) {
      alertify.error("Failed to fetch appointments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterStatus, search, page]);

    // Handle delete action
    const handleDeleteAppointment = async (appointmentId) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await deleteAppointment(appointmentId);
            Swal.fire("Deleted!", "The appointment has been deleted.", "success");
            fetchData({ page: 1, pageSize }); // Refresh the list after deletion
          } catch (error) {
            alertify.error("Failed to delete appointment");
          }
        }
      });
    };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Appointments List</h4>
              <h6>Manage appointments</h6>
            </div>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                onClick={() => {
                  history.push("appointment/manage");
                }}
              >
                <FeatherIcon icon="plus" className="me-1" />
                Add Appointment
              </Link>
            </div>
          </div>

          {/* Filter Navigation Tabs */}
          <div className="row comp-section">
            <div className="col-12 d-flex justify-content-center">
              <div>
                <ul
                  className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified mb-3 bg-white"
                  style={{ borderRadius: "24px", padding: "2px 2px" }}
                >
                  {["pending", "confirmed", "closed", "cancelled"].map(
                    (status) => (
                      <li className="nav-item" key={status}>
                        <a
                          className={`nav-link ${
                            filterStatus === status ? "active" : ""
                          }`}
                          onClick={() => setFilterStatus(status)}
                        >
                          {status.charAt(0).toUpperCase() + status.slice(1)}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/* Search Box */}
          <div className="row">
            <div className="col-12">
              <Tabletop
                OnChange={(e) => setSearch(e.target.value)}
                value={search}
              />
            </div>
          </div>

          {/* Appointments Table */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  isLoading={loading}
                  columns={columns}
                  response={{
                    data: data.map((item, index) => ({ ...item })),
                    totalDataCount: totalItems,
                  }}
                  fetchData={fetchData}
                  NoPagination={false}
                  onPageChange={(page) => setPage(page)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentsCRUD;